import { useCookies } from 'react-cookie'

export const useAppCookies = () => {
  const [cookies, setCookie, removeCookie] = useCookies()

  const defaultOptions = { path: '/', sameSite: 'strict' }

  const removeUserHashCookie = () => removeCookie('user_hash', defaultOptions)
  const removeLastUrlCookie = () => removeCookie('last_url', defaultOptions)
  const removeCoinCountsCookie = () => removeCookie('coin_counts', defaultOptions)
  const removePointCountsCookie = () => removeCookie('point_counts', defaultOptions)
  const removeOpenViewerCookie = () => removeCookie('open_viewer', { path: '/', sameSite: 'none', secure: true })
  const resetUserCookies = () => {
    removeUserHashCookie()
    removeCoinCountsCookie()
    removePointCountsCookie()
  }

  const setLastUrlCookie = (lastUrl) => {
    setCookie('last_url', lastUrl, defaultOptions)
  }

  const getOneYearFromNow = () => {
    const oneYearFromNow = new Date()
    oneYearFromNow.setFullYear(oneYearFromNow.getFullYear() + 1)
    return oneYearFromNow
  }

  const setSafeSearchCookie = (safeSearchSetting) => {
    setCookie('safe_search', safeSearchSetting, {
      ...defaultOptions,
      expires: getOneYearFromNow(),
    })
  }

  const setSafeSearchModalConfirmed = (isConfirmed) => {
    setCookie('safe_search_modal_confirmed', isConfirmed, {
      ...defaultOptions,
      expires: getOneYearFromNow(),
    })
  }

  // ビューワー話末 iframe から続巻を読む処理で使用
  // 作品詳細ページへ遷移する際に閲覧種別（購入済み or 無料）を一時保存し、
  // 遷移後にビューワーの自動起動判定に使うクッキー
  const setOpenViewerCookie = (type) => {
    const expires = new Date(Date.now() + 5 * 60 * 1000) // 5分
    setCookie('open_viewer', type, {
      path: '/',
      sameSite: 'none',
      secure: true,
      expires: expires,
    })
  }

  const setMonthlyCourseErrorCancelledOrderIdsCookie = (orderIds) => {
    const expires = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000) // 30日
    setCookie('monthly_course_error_cancelled_order_ids', orderIds, {
      ...defaultOptions,
      expires: expires,
    })
  }

  // 月額コース登録の前回の決済方法を保存
  const setLastMonthlyCoursePayTypeCookie = (payType) => {
    setCookie('last_monthly_course_pay_type', payType, defaultOptions)
  }

  return {
    userHashCookie: cookies?.user_hash,
    lastUrlCookie: cookies?.last_url,
    coinCountsCookie: cookies?.coin_counts,
    pointCountsCookie: Number(cookies?.point_counts || 0),
    safeSearchCookie: cookies?.safe_search,
    safeSearchModalConfirmed: cookies?.safe_search_modal_confirmed,
    ageVerificationConfirmedCookie: cookies?.age_verification_confirmed,
    openViewerCookie: cookies?.open_viewer,
    monthlyCourseErrorCancelledOrderIdsCookie: cookies?.monthly_course_error_cancelled_order_ids,
    lastMonthlyCoursePayTypeCookie: cookies?.last_monthly_course_pay_type,
    removeUserHashCookie: removeUserHashCookie,
    removeLastUrlCookie: removeLastUrlCookie,
    removeCoinCountsCookie: removeCoinCountsCookie,
    removePointCountsCookie: removePointCountsCookie,
    removeOpenViewerCookie: removeOpenViewerCookie,
    resetUserCookies: resetUserCookies,
    setLastUrlCookie: setLastUrlCookie,
    setSafeSearchCookie: setSafeSearchCookie,
    setSafeSearchModalConfirmed: setSafeSearchModalConfirmed,
    setOpenViewerCookie: setOpenViewerCookie,
    setMonthlyCourseErrorCancelledOrderIdsCookie: setMonthlyCourseErrorCancelledOrderIdsCookie,
    setLastMonthlyCoursePayTypeCookie: setLastMonthlyCoursePayTypeCookie,
  }
}
